import { extendTheme } from "@chakra-ui/react";
import styles from "./styles";
import fonts from "./fonts";
import textStyles from "./textStyles";
import layerStyles from "./layerStyles";
import colors from "./colors";
import FormLabel from "./components/FormLabel";
import Link from "./components/Link";
import Button from "./components/Button";
import Input from "./components/Input";
import Heading from "./components/Heading";
import Radio from "./components/Radio";
import Select from "./components/Select";
import Checkbox from "./components/Checkbox";

const overrides = {
  styles,
  fonts,
  textStyles,
  layerStyles,
  colors,
  components: {
    FormLabel,
    Link,
    Button,
    Input,
    Heading,
    Radio,
    Select,
    Checkbox,
  },
};

export default extendTheme(overrides);
